import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import { NamedLink } from '../../components';

import css from './ListingPage.module.css';

// Pick-3 locked decision #2: at most 3 contractors hold a pending slot on a request.
const MAX_ACTIVE_VENDORS = 3;

/**
 * Top of the homeowner's own request page: how many contractors they've picked (of 3),
 * with a link to the picker to choose the rest (or see their picks once all 3 are
 * chosen), and an "Edit request" button beside it.
 *
 * @param {Object} props
 * @param {Object} props.listing the request listing
 * @param {boolean} [props.canEdit] the homeowner can edit this request
 * @param {Function} [props.onEdit] opens the edit form
 * @returns {JSX.Element}
 */
const PicksSummary = ({ listing, canEdit, onEdit }) => {
  const publicData = listing?.attributes?.publicData || {};
  const pending = (publicData.vendorSelections || []).filter(s => s.status === 'pending').length;
  const remaining = Math.max(MAX_ACTIVE_VENDORS - pending, 0);
  const to = {
    search: `?category=${publicData.category || ''}&requestId=${listing.id.uuid}&from=request`,
  };

  return (
    <section className={css.picksSummary}>
      <div className={css.picksSummaryText}>
        <span className={css.picksSummaryLabel}>
          <FormattedMessage id="PicksSummary.label" />
        </span>
        <span className={css.picksSummaryCount}>
          <FormattedMessage
            id="PicksSummary.count"
            values={{ count: pending, max: MAX_ACTIVE_VENDORS }}
          />
        </span>
      </div>
      <div className={css.picksSummaryActions}>
        <NamedLink
          name="MatchedVendorsPage"
          to={to}
          className={remaining > 0 ? css.picksSummaryPrimary : css.picksSummarySecondary}
        >
          {pending === 0 ? (
            <FormattedMessage id="PicksSummary.chooseFirst" />
          ) : remaining > 0 ? (
            <FormattedMessage id="PicksSummary.chooseMore" values={{ count: remaining }} />
          ) : (
            <FormattedMessage id="PicksSummary.viewPicks" />
          )}
        </NamedLink>
        {canEdit ? (
          <button type="button" className={css.picksSummarySecondary} onClick={onEdit}>
            <FormattedMessage id="ListingPage.editRequest" />
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default PicksSummary;
